import React, { useEffect, useState } from 'react';
import { Container, Table, Button, Form, Alert, Row, Col } from 'react-bootstrap';
import { buildUrl } from '../helper/handler';
import { getFromApi, postToApi } from '../utilities/NetUtilities';
import { FaTrash } from 'react-icons/fa';
import { isValidEmail } from '../helper/validateEmail';

function GestioneEmailFrequenti() {
    const [emails, setEmails] = useState([]);
    const [nuovaEmail, setNuovaEmail] = useState('');
    const [message, setMessage] = useState({});

    useEffect(() => {
        const organizzazione = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const url = buildUrl('getemailfrequenti', {
            organizzazione: organizzazione.nome,
            tipo: organizzazione.tipo
        });

        const okAction = (data) => {
            setEmails(data.emailfrequenti);
        };

        const nokAction = (error) => {
            setMessage({ tipo: error.messaggi[0].tipo, descrizione: error.messaggi[0].descrizione });
        };

        getFromApi(url, okAction, nokAction);
    }, []);

    const handleAggiungiEmail = () => {
        if (!isValidEmail(nuovaEmail)) {
            setMessage({ tipo: 'warning', descrizione: "Il testo inserito non è un indirizzo email valido" });
            return;
        }
        const organizzazione = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const request = {
            email: nuovaEmail,
            organizzazione: organizzazione.nome,
            tipo: organizzazione.tipo
        };
        const url = buildUrl('addemailfrequente');

        const okAction = (data) => {
            setMessage({ tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione });
            setEmails(data.emailfrequenti);
            setNuovaEmail('');
        };

        const nokAction = (error) => {
            setMessage({ tipo: error.messaggi[0].tipo, descrizione: error.messaggi[0].descrizione });
        };

        postToApi(url, request, okAction, nokAction);
    };

    const handleEliminaEmail = (email) => {
        const organizzazione = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const request = {
            email: email,
            organizzazione: organizzazione.nome,
            tipo: organizzazione.tipo
        };
        const url = buildUrl('deleteemailfrequente');

        const okAction = (data) => {
            setMessage({ tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione });
            setEmails(data.emailfrequenti);
        };

        const nokAction = (error) => {
            setMessage({ tipo: error.messaggi[0].tipo, descrizione: error.messaggi[0].descrizione });
        };

        postToApi(url, request, okAction, nokAction);
    };

    const handleCloseAlert = () => {
        setMessage({});
    };

    return (
        <div className='main' role="main" onClick={handleCloseAlert}>
            <Container>
                <h1 className="d-flex justify-content-center inEvidenza">Gestione Email Frequenti</h1>
                {message.descrizione && (
                    <Alert variant={message.tipo} id="message" >
                        {message.descrizione}
                    </Alert>
                )}

                <div>
                    <Form onSubmit={(e) => { e.preventDefault(); handleAggiungiEmail(); }}>
                        <Row className="align-items-center space mb-3">
                            <Col xs={12}>
                                <Form.Label htmlFor="nuova-email" className="mb-1">Email</Form.Label>
                            </Col>
                            <Col xs={7} className="pe-0">
                                <Form.Control
                                    id="nuova-email"
                                    name="nuova-email"
                                    type="email"
                                    placeholder="Inserisci email"
                                    value={nuovaEmail}
                                    onChange={(e) => setNuovaEmail(e.target.value)}
                                    aria-label="Nuovo indirizzo email"
                                    data-testid="input-nuova-email"
                                />
                            </Col>
                            <Col xs={5} className="ps-2 d-flex justify-content-start align-items-center">
                                <Button
                                    className="btnGeneraleNoMargine"
                                    variant="flat"
                                    size="sm"
                                    type="submit"
                                    id="aggiungiEmail"
                                    data-testid="aggiungiEmail"
                                    style={{ whiteSpace: 'nowrap' }}
                                >
                                    Aggiungi Email
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
                {emails.length > 0 ? (
                    <Table className='space' striped bordered hover id="tabella-email-frequenti" data-testid="tabella-email-frequenti">
                        <thead>
                            <tr>
                                <th>Indirizzo Email</th>
                                <th>Elimina</th>
                            </tr>
                        </thead>
                        <tbody>
                            {emails.map((email, index) => (
                                <tr key={email} id={`riga-email-${index}`}>
                                    <td id={`indirizzo-email-${index}`}>{email}</td>
                                    <td className="d-flex justify-content-center">
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => handleEliminaEmail(email)}
                                            id={`elimina-email-${index}`}
                                            data-testid={`elimina-email-${index}`}
                                            className='aclibutton'
                                            title='Elimina email'
                                        >
                                            <FaTrash />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p className="text-center space" id="email-assenti">Non ci sono email</p>
                )}
            </Container>
        </div>
    );
}

export default GestioneEmailFrequenti;